import {
  createValidator,
	match,
	phoneRegex
} from '../../../../../util/form/validation';

export const validation = createValidator({
  'phoneNumber': match(
		phoneRegex,
		'Please enter a valid phone number'
  ),
});

export const fields = [
  'phoneNumber'
];



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/specialist/specialistHelpers.js
 **/